module.exports = __webpack_public_path__ + "img/teacher_bg.2564ea0b.png";